import {
  ExciseSelect,
  Props as ExciseSelectProps,
} from '@/components/ExciseSelect';
import { PaymentRequestForm } from '@/features/InvoiceReport/Edit/type';
import { memo, useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { CellProps } from './type';

type Props<TFieldValues extends PaymentRequestForm> =
  ExciseSelectProps<TFieldValues> & CellProps;

const InnerExciseSelectCell = <TFieldValues extends PaymentRequestForm>({
  index,
  ...props
}: Props<TFieldValues>) => {
  const cacheKey = useMemo(() => ['row', 'excise', index], [index]);
  const { setValue } = useFormContext<PaymentRequestForm>();
  const setLabelField = useCallback(
    (labelFieldValue: string) => {
      setValue(`invoiceTransactions.${index}.drExciseName`, labelFieldValue);
    },
    [setValue, index]
  );

  return (
    <ExciseSelect<TFieldValues>
      per={500}
      cacheQueryKey={cacheKey}
      {...props}
      setLabelField={setLabelField}
    />
  );
};
InnerExciseSelectCell.displayName = 'InnerExciseSelectCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ExciseSelectCell = memo(
  InnerExciseSelectCell
) as typeof InnerExciseSelectCell;
ExciseSelectCell.displayName = 'ExciseSelectCell';
